import { userManager } from './auth-config';

/**
 * RF-W13: where mock-mode login lands. `/` is the index route, which under
 * `--mode mock` redirects to `/coffee-console` (RF-W10) — so the demo comes
 * back up on the board it exists to show.
 */
export const LOGIN_SUCCESS_PATH = '/';

export const login = () => {
  // RF-W13: the exact inverse of `logout()` below. After a mock-mode
  // sign-out the success page's LOGIN button called `signinRedirect()`
  // against the placeholder Logto authority, which serves nothing under
  // `--mode mock`, so the offline demo could be signed out of but never back
  // into. Mock mode instead re-seeds the fake session through the SAME
  // `initMockAuth()` the app runs at startup (auth-provider.tsx) — its
  // module-level init flag was reset by `clearMockAuth`, so this really does
  // re-issue the token — and moves in-app with `pushState` + `popstate`, the
  // pair React Router's BrowserRouter listens to. Dynamic import, like
  // `logout()`, so no mock code reaches the real bundle.
  if (import.meta.env.VITE_USE_MOCK_DATA === 'true') {
    void import('@/lib/mock').then(({ initMockAuth }) => initMockAuth());

    window.history.pushState({}, '', LOGIN_SUCCESS_PATH);
    window.dispatchEvent(new PopStateEvent('popstate'));

    return;
  }

  userManager.signinRedirect();
};

/**
 * RF-W11: where mock-mode sign-out lands. `/sign-out` renders `<SignOut />`,
 * which calls `logout()`; the real flow ends on this route after Logto's
 * redirect, so mock mode ends there too.
 */
export const SIGN_OUT_SUCCESS_PATH = '/sign-out/success';

export const logout = () => {
  // RF-W11: under `--mode mock` there is no Logto — `VITE_LOGTO_AUTH_BASE_URL`
  // points at a placeholder that serves nothing — so `signoutRedirect()`
  // navigates the operator off the app to a dead authority and the demo is
  // over. Mock mode instead drops the fake session and moves to the sign-out
  // success route in-app. `pushState` + `popstate` is what React Router's
  // BrowserRouter listens to, so this is a real route change (SignOutSuccess
  // renders) with no full reload and no OIDC round trip. The mock module is
  // reached by dynamic import, the same way `auth-provider.tsx` does, so none
  // of the mock layer is pulled into the real bundle.
  if (import.meta.env.VITE_USE_MOCK_DATA === 'true') {
    void import('@/lib/mock').then(({ clearMockAuth }) => clearMockAuth());

    window.history.pushState({}, '', SIGN_OUT_SUCCESS_PATH);
    window.dispatchEvent(new PopStateEvent('popstate'));

    return;
  }

  userManager.signoutRedirect();
};

// Use this to reset a password or set up a new password for a user account
export const resetPassword = (email: string) => {
  userManager.signinRedirect({
    login_hint: email,
    extraQueryParams: {
      first_screen: 'reset_password', // Logto-specific param
      resource: import.meta.env.VITE_LOGTO_API_RESOURCE, // must include for token request
    },
    extraTokenParams: {
      resource: import.meta.env.VITE_LOGTO_API_RESOURCE, // must include for token request
    },
  });
};
